import { Button } from "@components/ui/button"
import { useDrawer } from "@contexts/DrawerContext"
import { AddProspectNoteForm } from "./AddProspectNoteForm"
import { AddProspectContactForm } from "./AddProspectContactForm"

type TEventsActionButtonsProps = {
  prospect_guid: string | undefined
}

export const EventsActionButtons = ({
  prospect_guid,
}: TEventsActionButtonsProps) => {
  const { openDrawer, closeDrawer } = useDrawer()

  return (
    <div className="tw:inline-flex tw:[&>button]:rounded-none tw:[&>button:first-child]:rounded-l-md tw:[&>button:last-child]:rounded-r-md">
      <Button
        key="contact_btn"
        variant="outline"
        onClick={() =>
          openDrawer(
            <AddProspectContactForm
              prospect_guid={prospect_guid as string}
              onCancel={closeDrawer}
              onSubmitSuccess={closeDrawer}
            />,
            "Add a Contact",
          )
        }
      >
        Add Contact
      </Button>
      <Button
        key="note_btn"
        variant="outline"
        onClick={() =>
          openDrawer(
            <AddProspectNoteForm
              prospect_guid={prospect_guid as string}
              onCancel={closeDrawer}
              onSubmitSuccess={closeDrawer}
            />,
            "Add a Note",
          )
        }
      >
        Add Note
      </Button>
    </div>
  )
}
